import React from "react";
import "@/stylesheets/components/generic/radioButton.scss";

export interface IListObj {
  href?: string | undefined;
  value: number | string;
  display: string;
  primary?: boolean;
}

export interface RadioButtonProps {
  list: IListObj; //list of all options in radio btn
  name: string;
  selected?: number | string; // selected value
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void; // function to be called on change
  moduleName?: string; //
  disabled?: boolean;
  className?: string;
}

const Checkbox: React.FC<RadioButtonProps> = (props) => {
  const moduleName = props.moduleName ? props.moduleName : "";

  return (
    <div className={`radio-button ${props.className}`}>
      <label className={"radio_btn " + moduleName}>
        <input
          type="checkbox"
          value={props?.list?.value}
          name={props?.name}
          key={props?.list?.value}
          checked={props?.selected === props?.list?.value}
          onChange={props?.onChange}
          disabled={props?.disabled ? props.disabled : false}
        />

        <span className="disp_val DMSanN_14_400 txt_blackOne1 hand_cursor">
          {props?.list?.display}
        </span>
      </label>
    </div>
  );
};

export default Checkbox;
